import ls from 'local-storage';

class Storage {
  save = async (key, data) => {
    try {
      await ls.set(key, JSON.stringify(data));
    } catch (e) {
      console.log(e);
    }
  };

  remove = async (key) => {
    try {
      await ls.remove(key);
      console.log('done');
    } catch (e) {
      console.log(e);
    }
  };

  load = async (key) => {
    try {
      const value = await ls(key);
      if (value !== null) {
        try {
          return JSON.parse(value);
        } catch (e) {
          return value;
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
}

const storage = new Storage();

export { storage };
